import API from "./../../services/api/backend";

export function newsletterSubcribe(email) {
  return API.backendUnhandled({
    url: API.endpoints.subscriptions,
    method: API.methods.POST,
    data: { email }
  });
}
